import React, { Component, Fragment, useEffect, useState } from "react"
import FieldLabelToolTip from "../FieldLabelToolTip/fieldLabelToolTip";
import SimpleDropdown from "../SimpleDropdown"
import "./styles.css"

class TelephoneNumber extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { countryCodes, areaCodes, onChange, number = '', countryCode, areaCode, properties = {
            countryCode: { label: '', name: '', id: '' },
            areaCode: { label: '', name: '', id: '' },
            number: { label: '', name: '', id: '' },
            tooltip: {
                label: '', name: '', data: ''
            }
        },
            a11yProperties = {
                ariaDescribedBy: ''
            }
        } = this.props

        return (
            <React.Fragment>
                <section className='telephone-wrapper'>
                    <section>
                        <div>
                            <Fragment>
                                <label className='telephone-label' htmlFor={properties.countryCode.id}>
                                    <span className='telephone-label'>
                                        {properties.countryCode && properties.countryCode.label && properties.countryCode.label.split("/")[0]} /
                                    </span>
                                    <span className='telephone-label'>
                                        {properties.countryCode && properties.countryCode.label && properties.countryCode.label.split("/")[1]}
                                    </span>
                                </label>
                            </Fragment>
                        </div>
                        <SimpleDropdown
                            defaultValue="None"
                            value={(countryCode && countryCode.name) || ''}
                            _onChange={
                                onChange
                            }
                            options={countryCodes}
                            optionTextSelector="name"
                            valueSelector="name"
                            name={properties.countryCode.name}
                            id={properties.countryCode.id}
                            bsClass='telephone-country-code'
                            showPleaseSelectOption
                            allowDefaultSelection
                        ></SimpleDropdown>
                    </section>
                    {countryCode && countryCode.name === "+1" ?
                        <section className='telephone-area-code'>
                            <label className='telephone-label' htmlFor={properties.areaCode.id}>{properties.areaCode.label}</label>
                            <SimpleDropdown
                                defaultValue="None"
                                value={(areaCode && areaCode.name) || ''}
                                _onChange={onChange}
                                options={areaCodes}
                                optionTextSelector="name"
                                valueSelector="name"
                                name={properties.areaCode.name}
                                id={properties.areaCode.id}
                                bsClass='telephone-area-code'
                                showPleaseSelectOption
                                allowDefaultSelection={false}
                            ></SimpleDropdown>
                        </section>
                        : null}
                    <section className='telephone-phone-number'>
                        <label className='telephone-label' htmlFor={properties.number.id}>{properties.number.label}</label>
                        <input
                            type="text"
                            name={properties.number.name}
                            id={properties.number.id}
                            aria-describedby={a11yProperties.ariaDescribedBy}
                            value={number}
                            onChange={onChange}
                        />
                    </section>
                    <section style={{ height: "2.375rem" }}>
                        {properties.tooltip ? <FieldLabelToolTip label={properties.tooltip && properties.tooltip.label}
                            tooltip={properties.tooltip && properties.tooltip.data}
                            name={properties.tooltip && properties.tooltip.name} /> : ''}
                    </section>
                </section>
            </React.Fragment>
        )
    }
}

export default TelephoneNumber


// WEBPACK FOOTER //
// ./src/components/common/TelephoneNumber/index.js